import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { ToastrManager } from 'ng6-toastr-notifications';
import { finalize } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { FormControl, Validators } from '@angular/forms';
import { FireFileService } from '../../../QMModuleApp/_core/services/filefire.service';
import * as FileSaver from 'file-saver';
@Component({
  selector: 'm-file-fire-manager',
  templateUrl: './file-fire-manager.component.html',
  styleUrls: ['./file-fire-manager.component.css']
})
export class FileFireManagerComponent implements OnInit {
  @Input() url_firebase:string=null;
  @Input() requerido:boolean=false;
  @Input() view_only:boolean=false;
  @Input() extensionAceptados?:any[]=['.png', '.jpeg', '.gif'];
  @Input() mostrarCajaDeTexto:boolean=true;
  @Input() puedeCargarArchivo:boolean=true;
  @Input() puedeDescargarArchivo:boolean=true;
  @Input() puedeEliminarArchivo:boolean=true;
  @Input() peso_maximo_mb: number=10;
  @Input() modo: string = "CARTILLAS";
  @Input() carpetasFireBase: string[]=['CARTILLA_NAME','TIPO_DATO'];

  @Output() FilesSaveChange = new EventEmitter();
  @Output() FileDeleteChange = new EventEmitter();
  nombreSeleccionArchivo:string=null;//'Ingrese archivo';
  formControl:FormControl=new FormControl();
  file_name:string=null;cargando:boolean=false;isUploaded=false;
  constructor(
    private toastr: ToastrManager,
    public cd: ChangeDetectorRef,
    private service:FireFileService
  ) { }

  ngOnInit(): void {
    if(this.requerido){
      this.formControl.setValidators(Validators.required);
    }  
    if(this.url_firebase){
      this.nombreSeleccionArchivo="El archivo ya fue registrado";
      this.isUploaded=true;
    }
    this.cd.detectChanges();
    this.cd.markForCheck();
  }

  file=null;base_64=null;
  load_file_event(event){
    if (event.target.files.length > 0  && event.target.files[0].size<= 1024*1024*this.peso_maximo_mb && event.target.files[0].size!= undefined ) {
      const files: { [key: string]: File } = event.target.files;
      for (let key in files) {
        if (!isNaN(parseInt(key))) {this.file = files[key];}
      }
    } else {
      if (event.target.files[0].size > 1024*1024*this.peso_maximo_mb){
        this.toastr.warningToastr('El tamaño excede a los 8Mb de capacidad. No se podra guardar', 'Advertencia!', {
          toastTimeout: 2000,
          showCloseButton: true,
          animate: 'fade',
          progressBar: true
        });
      }
      this.file = null;
    }
    this.file_name = this.file?this.file.name:null;
  }
  to_base64(reader,file){
    this.file_name = file.name;
    this.base_64 =  reader.result;
    this.cargando=false;
    this.cd.detectChanges(); this.cd.markForCheck();
  };


  upload_file_to_firebase(){
    this.cargando=true;this.isUploaded=false;
    const formData = new FormData();
    if(!this.formControl.invalid){
      if(this.modo=="CARTILLAS" && this.file){
        formData.append('file', this.file);
        formData.append('tipo_dato',this.carpetasFireBase[1]);
        formData.append('cartilla_name',this.carpetasFireBase[0]);
        this.service.SaveFileFirebaseCartillas(formData).subscribe((response:any) => {
          if(response.status){
            this.url_firebase=response.msg;
          }else{
            this.url_firebase=null;
            this.toastr.warningToastr(response.msg, 'Advertencia!', {
              toastTimeout: 2000,
              showCloseButton: true,
              animate: 'fade',
              progressBar: true
            });
          }
          this.isUploaded=true;
          this.cargando=false;
          this.cd.detectChanges();this.cd.markForCheck();
          this.FilesSaveChange.emit(this.url_firebase);
        });
      }
    }else{
      this.toastr.warningToastr('Debe ingresar un archivo para su subida', 'Advertencia!', {
        toastTimeout: 2000,
        showCloseButton: true,
        animate: 'fade',
        progressBar: true
      });
    }
  }

  onRemoveFileItem=()=>{
    this.file=null;this.file_name=null;this.base_64=null; this.url_firebase=null;
    this.nombreSeleccionArchivo="El archivo ya fue registrado";
    this.FileDeleteChange.emit(true);
  }
  onDownloadFileItem=()=>{
    window.open(this.url_firebase, "_blank")
  }


}
